import React, { Component } from "react";
import ReactModal from "react-modal";
import { apiUrl3, report, web5, selectedfolder, mailreprt} from "../../config/config";
import { apiUrl } from "../../config/config";
import axios from "axios";
import Dropdown from "react-dropdown";
import "react-dropdown/style.css";
import Loader from "react-loader-spinner";
import "./modals.css";
import { end } from "@popperjs/core";

class AddModalReport extends Component {
  // ... skip
  constructor() {
    super();
    this.state = {
      showModalReportComplete: false,
      showModalNewComplete: false,
      showModalReportSpinnerComplete: false,
      startProp: "",
      userid: "",
      optionsnewone: [],
      optionsnewoneend: [],
      start_generate: "",
      end_generate: "",
    };
    this.handleCloseModalReportComplete =
      this.handleCloseModalReportComplete.bind(this);
    this.handleCloseModalReportSpinnerNewComplete =
      this.handleCloseModalReportSpinnerNewComplete.bind(this);
    this.handleOpenModalReportSpinnerNewComplete =
      this.handleOpenModalReportSpinnerNewComplete.bind(this);
  }
  onChange = (e) => {
    console.log(e.target.name);
    console.log(e.target.value);
    this.setState({ [e.target.name]: e.target.value });
  };
  componentDidMount() {
    ReactModal.setAppElement("body");
    window.analyzeLink = "";
  }

  componentWillReceiveProps(nextProps) {
    this.state.userid = nextProps.userid;
    this.state.startProp = nextProps.start;
    var instance = nextProps.inst;

    var technologyList = [];
    var technologyListEnd = [];
    var optionnew = [];
    var optionnewend = [];
    var i = 0,
      j = 0;
    if (nextProps.isOpen == true) {
      Object.keys(this.props.treemenu).map((val, key) => {
        this.props.treemenu[val].map((value, key1) => {
          var MainTime = value["date"].split("T");
          var time = MainTime[1].split("+");

          optionnew[i] = val + " " + time[0];
          optionnewend[i] = val + " " + time[0];
          // technologyList.push(<option value={ val+" "+time[0]}>{ val+" "+time[0]}</option>)
          i = i + 1;
        });
      });

      optionnew = optionnew.sort();
      this.setState({ start_generate: optionnew[0] });

      for (j = 0; j < optionnew.length; j++) {
        technologyList.push(
          <option value={optionnew[j]}>{optionnew[j]}</option>
        );
      }

      optionnewend = optionnewend.sort(function (a, b) {
        return b - a;
      });
      this.setState({ end_generate: optionnewend[0] });
      for (j = 0; j < optionnewend.length; j++) {
        technologyListEnd.push(
          <option value={optionnewend[j]}>{optionnewend[j]}</option>
        );
      }

      this.setState({ optionsnewone: technologyList });
      this.setState({ optionsnewoneend: technologyListEnd });

      this.state.showModalReportComplete = nextProps.isOpen;
    }
  }
  handleCloseModalReportComplete() {
    this.setState({ showModalReportComplete: false });
    this.setState({ showModalReportComplete: false });
    this.props.onSelectModalReport();
  }

  handleCloseModalNewComplete() {
    console.log("handleCloseModalNewComplete");
    this.setState({ showModalNewComplete: false });
  }

  handleCloseModalReportSpinnerNewComplete() {
    console.log("handleCloseModalNewComplete");
    this.setState({ showModalReportSpinnerComplete: false });
  }

  handleOpenModalReportSpinnerNewComplete() {
    console.log("handleCloseModalNewComplete");
    this.setState({ showModalReportSpinnerComplete: true });
  }

  handleOpenModalSpinnerNew() {
    console.log("handleCloseModalNewComplete");
    this.setState({ showModalReportSpinnerComplete: true });
  }

  // New format report model

  openGeneratemodal(e) {
    this.setState({ showModalReportComplete: false });
    this.handleOpenModalReportSpinnerNewComplete();

    var userid         = this.state.userid;
    // POST body fields are JSON, not URL-encoded — pass the raw
    // "YYYY-MM-DD HH:MM:SS" timestamp through. The previous .replace
    // converted the space to %20 thinking it was a URL param, but
    // Python then received the literal string "...%20..." instead of
    // a real space and couldn't parse it as a datetime.
    var start_generate = String(this.state.start_generate || "");
    var end_generate   = String(this.state.end_generate   || "");

    // ── CRITICAL: open the new tab RIGHT NOW, inside the same click
    //   handler. Popup blockers reject window.open() from a later
    //   async .then() callback because it's no longer a user gesture.
    //   We open a loading-state placeholder tab now and navigate it
    //   once the backend signals the report is ready.
    var reportTab = window.open("about:blank", "_blank");
    if (reportTab && reportTab.document) {
      reportTab.document.write(
        "<!doctype html><html><head>" +
        "<title>Generating report…</title>" +
        "<style>" +
        "body{font-family:system-ui,sans-serif;padding:48px 32px;" +
        "background:#0f3035;color:#e2eef2;text-align:center;}" +
        "h2{color:#2eaabb;font-weight:600;margin:0 0 12px;}" +
        "p{color:#9ab3bd;margin:8px 0;}" +
        ".spin{width:56px;height:56px;border:6px solid #1a3a3a;" +
        "border-top:6px solid #2eaabb;border-radius:50%;margin:28px auto;" +
        "animation:s 1s linear infinite;}" +
        "@keyframes s{to{transform:rotate(360deg)}}" +
        "</style></head><body>" +
        "<h2>Generating report…</h2>" +
        "<p>Please keep this tab open — it'll refresh automatically</p>" +
        "<p>when the PDF is ready (usually 30–90 seconds).</p>" +
        "<div class='spin'></div>" +
        "<p style='font-size:11px;opacity:0.6;'>You can keep working in the other tab.</p>" +
        "</body></html>"
      );
    }

    // ── Kick off the backend job. The route now returns a jobId
    //   immediately (Python runs detached); we poll for completion.
    //
    //   LEFT button (this one) → COLOR-format report.
    //   Python expects color="blue" for the colored PDF template.
    var self = this;
    axios
      .post(`${apiUrl}api/graph/GenerateReport_New_graph`, {
        userid:     userid,
        databaseid: this.state.databaseid || this.state.clickdata || "",
        start:      start_generate,
        end:        end_generate,
        color:      "blue",           // ← left-side button: colored report
      })
      .then(function (res) {
        var jobId = res && res.data && res.data.jobId;
        if (jobId) {
          // New async backend — poll for done
          self.pollReportJob(jobId, reportTab);
        } else {
          // Old sync backend still in place — Python already finished,
          // navigate the placeholder tab now.
          self.handleCloseModalReportSpinnerNewComplete();
          if (self.props.onSelectModalReport) self.props.onSelectModalReport();
          if (reportTab && !reportTab.closed) {
            reportTab.location.href = report + "?userid=" + userid;
            reportTab.focus();
          }
          window.location.reload();
        }
      })
      .catch(function (err) {
        console.log(err);
        self.handleCloseModalReportSpinnerNewComplete();
        if (reportTab && !reportTab.closed) reportTab.close();
        alert("Failed to start report generation. Try again.");
      });
  }

  // Poll the backend until the report job finishes. Navigates the
  // pre-opened placeholder tab to the actual report URL when done.
  pollReportJob(jobId, reportTab) {
    var self    = this;
    var userid  = this.state.userid;
    var attempts = 0;
    var MAX     = 300;       // 300 × 2s = 10 min ceiling
    var INTERVAL = 2000;

    // Save the jobId into localStorage so the user can grep the
    // backend logs after the fact. Stamped + timestamped so multiple
    // runs are distinguishable.
    try {
      var hist = JSON.parse(localStorage.getItem("reportJobs") || "[]");
      hist.push({ jobId: jobId, userid: userid, startedAt: new Date().toISOString() });
      localStorage.setItem("reportJobs", JSON.stringify(hist.slice(-20)));
    } catch (e) { /* ignore */ }
    // eslint-disable-next-line no-console
    console.log("[Report] kicked off jobId =", jobId,
                "→ check /var/log/holter-jobs/" + jobId + ".{log,err,done}");

    // Render an error page in the placeholder tab so the user can read
    // the Python traceback without it disappearing under a reload.
    function showErrorInTab(message, jobId) {
      if (!reportTab || reportTab.closed) return;
      try {
        var safeMsg = String(message || "(no error message)")
          .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
        reportTab.document.open();
        reportTab.document.write(
          "<!doctype html><html><head>" +
          "<title>Report failed</title>" +
          "<style>" +
          "body{font-family:system-ui,sans-serif;padding:32px;" +
          "background:#1f0f10;color:#fdb6c0;}" +
          "h2{color:#ff6b6b;font-weight:600;margin:0 0 12px;}" +
          "code{display:block;background:#000;color:#ff8a8a;padding:14px 18px;" +
          "border-radius:6px;font-family:ui-monospace,monospace;font-size:12px;" +
          "white-space:pre-wrap;word-break:break-all;line-height:1.45;" +
          "max-height:80vh;overflow:auto;}" +
          "p{color:#c89a9e;font-size:13px;margin:8px 0;}" +
          ".hint{margin-top:16px;background:#2a1416;padding:12px 16px;" +
          "border-left:3px solid #ff6b6b;border-radius:4px;font-size:12.5px;}" +
          "</style></head><body>" +
          "<h2>Report generation failed</h2>" +
          "<p>Job ID: <b>" + jobId + "</b></p>" +
          "<p>Python stderr (last 1KB):</p>" +
          "<code>" + safeMsg + "</code>" +
          "<div class='hint'>" +
          "On the server, the full logs are at:<br>" +
          "<code style='display:inline-block;padding:6px 10px;margin-top:6px;background:#000;color:#5ac8fa;'>" +
          "/var/log/holter-jobs/" + jobId + ".err</code>" +
          "</div></body></html>"
        );
        reportTab.document.close();
      } catch (e) { /* ignore — cross-origin guard etc. */ }
    }

    var tick = function () {
      attempts++;
      if (attempts > MAX) {
        self.handleCloseModalReportSpinnerNewComplete();
        showErrorInTab("Timed out after 10 minutes — Python script still running. "
                     + "Check the server-side log files for status.", jobId);
        // eslint-disable-next-line no-console
        console.error("[Report] jobId", jobId, "timed out after", MAX, "polls");
        return;
      }

      axios
        .get(apiUrl + "api/graph/reportStatus?jobId=" + jobId
             + "&_=" + Date.now(),                              // cache-busting timestamp
             { headers: {
                 "Cache-Control": "no-cache",
                 "Pragma":        "no-cache",
                 "Expires":       "0",
             }})
        .then(function (res) {
          var status = res && res.data && res.data.status;
          if (status === "done") {
            self.handleCloseModalReportSpinnerNewComplete();
            if (self.props.onSelectModalReport) self.props.onSelectModalReport();
            // Navigate the pre-opened tab to the actual report.
            if (reportTab && !reportTab.closed) {
              reportTab.location.href = report + "?userid=" + userid;
              try { reportTab.focus(); } catch (e) { /* ignore */ }
            } else {
              var t = window.open(report + "?userid=" + userid, "_blank");
              if (!t) {
                alert("Report ready, but the new tab was blocked. " +
                      "Allow popups for this site and click again.");
              }
            }
            // Reload the parent page so the patient's report_status
            // (now "In Preparation" / "Report Generated") is re-fetched
            // and the row's status badge / button label updates. Delay
            // 1.5s so the user has time to see the new tab open
            // BEFORE the source page reloads, and DevTools stays
            // useful for the network roundtrip.
            setTimeout(function () {
              window.location.reload();
            }, 1500);
          } else if (status === "failed") {
            self.handleCloseModalReportSpinnerNewComplete();
            var msg = (res.data && res.data.error) || "Unknown error";
            // eslint-disable-next-line no-console
            console.error("[Report] jobId", jobId, "FAILED:\n" + msg);
            // Render error inline in the placeholder tab — stays open
            // so the user can read the Python traceback as long as they want
            showErrorInTab(msg, jobId);
          } else {
            // status === "running" (or anything else): keep polling
            setTimeout(tick, INTERVAL);
          }
        })
        .catch(function (err) {
          // eslint-disable-next-line no-console
          console.log("[Report] poll transient error:", err && err.message);
          setTimeout(tick, INTERVAL * 2);
        });
    };

    setTimeout(tick, INTERVAL);
  }

  // Old format report model
  openGeneratemodalNew(e) {
    this.setState({ showModalReportComplete: false });
    this.handleOpenModalReportSpinnerNewComplete();

    var userid         = this.state.userid;
    // POST body fields are JSON, not URL-encoded — see comment in
    // openGeneratemodal for the same fix.
    var start_generate = String(this.state.start_generate || "");
    var end_generate   = String(this.state.end_generate   || "");

    // Same async pattern as openGeneratemodal — open a placeholder
    // tab synchronously in this user-click handler (popup blockers
    // block window.open() from later async callbacks), fire the
    // backend job, then poll until done and navigate the placeholder.
    var reportTab = window.open("about:blank", "_blank");
    if (reportTab && reportTab.document) {
      reportTab.document.write(
        "<!doctype html><html><head>" +
        "<title>Generating report…</title>" +
        "<style>" +
        "body{font-family:system-ui,sans-serif;padding:48px 32px;" +
        "background:#0f3035;color:#e2eef2;text-align:center;}" +
        "h2{color:#2eaabb;font-weight:600;margin:0 0 12px;}" +
        "p{color:#9ab3bd;margin:8px 0;}" +
        ".spin{width:56px;height:56px;border:6px solid #1a3a3a;" +
        "border-top:6px solid #2eaabb;border-radius:50%;margin:28px auto;" +
        "animation:s 1s linear infinite;}" +
        "@keyframes s{to{transform:rotate(360deg)}}" +
        "</style></head><body>" +
        "<h2>Generating report…</h2>" +
        "<p>Please keep this tab open — it'll refresh automatically</p>" +
        "<p>when the PDF is ready (usually 30–90 seconds).</p>" +
        "<div class='spin'></div>" +
        "</body></html>"
      );
    }

    // RIGHT button (this one) → GREYSCALE-format report.
    // Python expects color="grey" for the grayscale PDF template.
    var self = this;
    axios
      .post(`${apiUrl}api/graph/GenerateReport_New_path`, {
        userid:     userid,
        databaseid: this.state.databaseid || this.state.clickdata || "",
        start:      start_generate,
        end:        end_generate,
        color:      "grey",           // ← right-side button: grayscale report
      })
      .then(function (res) {
        var jobId = res && res.data && res.data.jobId;
        if (jobId) {
          // New async backend — poll for done. Reuses pollReportJob
          // defined above; same flow, just a different POST URL.
          self.pollReportJob(jobId, reportTab);
        } else {
          // Old sync backend still in place — assume Python already
          // finished and navigate the placeholder tab now.
          self.handleCloseModalReportSpinnerNewComplete();
          if (self.props.onSelectModalReport) self.props.onSelectModalReport();
          if (reportTab && !reportTab.closed) {
            reportTab.location.href = report + "?userid=" + userid;
            reportTab.focus();
          }
          window.location.reload();
        }
      })
      .catch(function (err) {
        console.log(err);
        self.handleCloseModalReportSpinnerNewComplete();
        if (reportTab && !reportTab.closed) reportTab.close();
        alert("Failed to start report generation. Try again.");
      });
  }
  // select report format
  analyzeDataset(e) {
    var userid = this.state.userid;
    var databaseid = this.state.clickdata;
    /*  if(e.currentTarget.id=='ai')
    {
        console.log('Select',e.currentTarget.id);
        
        window.analyzeLink='/home/ubuntu/analysis_codes/ai_codes/full_analyze.py';
    }
    else if(e.currentTarget.id=='hybrid')
    {
        console.log('Select',e.currentTarget.id);
        window.analyzeLink='/home/ubuntu/analysis_codes/classic_peak/full_analyze.py';
    }
    else if(e.currentTarget.id=='classical')
    {
        console.log('Select',e.currentTarget.id);
        window.analyzeLink='/home/ubuntu/analysis_codes/classical_code/full_analyze.py';
    }
    else if(e.currentTarget.id=='temp1')
    {
        console.log('Select',e.currentTarget.id);
        window.analyzeLink='/home/ubuntu/analysis_codes/ai_codes/classic_negpeak/full_analyze.py';
    }
    else if(e.currentTarget.id=='temp2')
    {
        console.log('Select',e.currentTarget.id);
        window.analyzeLink='/home/ubuntu/analysis_codes/pvc_model/full_analyze.py';
    }
    console.log('window.analyzeLink',window.analyzeLink);
    console.log('uid',userid);
    console.log('uid',databaseid);*/
    if (window.analyzeLink != "") {
      var userid = this.state.userid;
      var databaseid = this.state.clickdata;
      e.currentTarget.innerHTML = "Generating Reports.....";
      //const userid = this.props.match.params.userid;
      this.handleCloseModalNewComplete();
      this.handleOpenModalSpinnerNew();
      axios
        .get(
          "https://web.mybiocalculus.com/html/welcome/analyzeAll/?userid=" +
          userid +
          "&&type=" +
          window.analyzeLink
        )
        .then((res) => {
          console.log(res.data);
          this.handleCloseModalReportSpinnerNewComplete();
          this.props.onSelectModalReport(); // close the parent modal
          window.location.reload(); // reload so reportStatus reflects new analysis state
        })
        .catch((err) => {
          console.log(err);
          this.handleCloseModalReportSpinnerNewComplete();
        });
    }
  }
  /*  _onSelect(e)
  {
  
    if(e.value=='RPeaks')
    {
        console.log('Select',e.value);
        window.analyzeLink='/home/biocalculusssh/web_analysis/rpeaks_codes/full_analyze.py';
    }
    else if(e.value=='Classic')
    {
        console.log('Select',e.value);
        window.analyzeLink='/home/biocalculusssh/web_analysis/classic_peak/full_analyze.py';
    }
    else if(e.value=='Classical')
    {
        console.log('Select',e.value);
        window.analyzeLink='/home/biocalculusssh/web_analysis/classical_code/full_analyze.py';
    }
    else if(e.value=='Classic Negative')
    {
        console.log('Select',e.value);
        window.analyzeLink='/home/biocalculusssh/web_analysis/classic_negpeak/full_analyze.py';
    }
    else if(e.value=='AI')
    {
        console.log('Select',e.value);
        window.analyzeLink='/home/biocalculusssh/web_analysis/ai_codes/full_analyze.py';
    }
    else if(e.value=='AIcodes')
    {
        console.log('Select',e.value);
        window.analyzeLink='/home/biocalculusssh/web_analysis/saroja_aicodes/full_analyze.py';
    }
   
  }
*/
  render() {
    /* const imageList = [{
  src: '../../dist/img/AI.png',
  width: 152,
  height: 102
}, {
  src: '../../dist/img/AI.png',
  width: 152,
  height: 102
}, {
  src: '../../dist/img/AI.png',
  width: 152,
  height: 102
}, {
  src: '../../dist/img/AI.png',
  width: 152,
  height: 102
},{
  src: '../../dist/img/AI.png',
  width: 152,
  height: 102
}, {
  src: '../../dist/img/AI.png',
  width: 152,
  height: 102
}];*/
    const text = "Generating Report.....";
    const customStyles = {
      content: {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)", // Ensures perfect centering
        background: "transparent",
        border: "none", // Removes borders
        padding: 0, // Ensures no extra space around content
        display: "flex", // Aligns spinner properly
        justifyContent: "center", // Centers spinner horizontally
        alignItems: "center", // Centers spinner vertically
      },
      overlay: {
        backgroundColor: "rgba(0, 0, 0, 0.5)", // Adds a semi-transparent overlay
      },
    };

    const customStylesNew = {
      content: {
        top: "38%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        border: "1px solid rgb(204, 204, 204)",
        background: "rgb(255, 255, 255)",
        overflow: "auto",
        borderRadius: "4px",
        outline: "none",
        padding: "20px",
        height: "45%",
        width: "35%",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)",
      },
    };
    /*const options = [
         'RPeaks', 'Classic', 'Classical','Classic Negative', 'AI','AIcodes'
        ];
         const defaultOption = options[0];
    */
    // console.log(this.state.showModalReportComplete)
    return (
      <React.Fragment>
        <ReactModal isOpen={this.state.showModalReportSpinnerComplete} style={customStyles}>
          <Loader type="Puff" color="#00BFFF" height={100} width={100} />
          <div className="bounce-container">
            {text.split("").map((char, index) => (
              <span
                key={index}
                className="bounce-letter"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                {char}
              </span>
            ))}
          </div>
        </ReactModal>
        <ReactModal
          isOpen={this.state.showModalReportComplete}
          style={customStyles}
          contentLabel="Example Modal"
        >
          <React.Fragment>
            <div className="blog-pop-bg"></div>
            <div className="blog-pop-box">
              <button
                className="pull-right closeBtn"
                onClick={this.handleCloseModalReportComplete}
              >
                &#10006;
              </button>
              <div
                className="fea pull-left"
                style={{ marginRight: "50px", background: "white" }}
              >
                <table>
                  <tr>
                    <td>
                      {" "}
                      <button style={{ border: "none" }}>
                        <img
                          onClick={this.openGeneratemodal.bind(this)}
                          src="../../../../../dist/img/new_report.png"
                          alt=""
                        />
                      </button>
                      <button style={{ border: "none" }}>
                        <img
                          onClick={this.openGeneratemodalNew.bind(this)}
                          src="../../../../../dist/img/new_report.png"
                          alt=""
                        />
                      </button>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <select
                        name="start_generate"
                        onChange={this.onChange}
                        style={{ color: "black", width: "50%",backgroundColor:"white" }}
                      >
                        {this.state.optionsnewone}
                      </select>
                      <select
                        name="end_generate"
                        onChange={this.onChange}
                        style={{ color: "black", width: "50%",backgroundColor:"white" }}
                      >
                        {" "}
                        {this.state.optionsnewoneend}
                      </select>
                    </td>
                  </tr>
                </table>
              </div>

              <br />
            </div>
          </React.Fragment>
        </ReactModal>
      </React.Fragment>
    );
  }
}

export default AddModalReport;
